module.exports = __webpack_public_path__ + "static/media/GM.d56c44fb.png";